module.exports = __webpack_public_path__ + "static/media/pindrop-comments.0907555c.svg";